export default "__VITE_ASSET__CeZ4Dtc3__"